
import CancelledIcon from 'assets/tasks/cancelled.png';
import CompletedIcon from 'assets/tasks/completed.png';
import FailedIcon from 'assets/tasks/failed.png';
import InProgressIcon from 'assets/tasks/in-progress.png';
import OnHoldIcon from 'assets/tasks/on-hold.png';
import OutreachIcon from 'assets/tasks/outreach.png';
import RequestedIcon from 'assets/tasks/requested.png';
import type { SemanticCOLORS, SemanticICONS } from 'semantic-ui-react';

type ColorRecord = Record<string, SemanticCOLORS>;
type IconRecord = Record<string, SemanticICONS>;

export const PRIORITY_ICON_COLORS: ColorRecord = {
  routine: 'blue',
  urgent: 'yellow',
  asap: 'orange',
  stat: 'red',
};

export const PRIORITY_ICONS: IconRecord = {
  urgent: 'warning sign',
  asap: 'lightning',
  stat: 'fire',
};

export const TASK_BORDER = {
  pastdue: '2px solid red',
  today: '2px solid green',
  future: '',
};

export const TASK_DUE_DATE_ICON: IconRecord = {
  pastdue: 'exclamation',
  today: 'hourglass half',
};

export const TASK_DUE_DATE_COLORS: ColorRecord = {
  pastdue: 'red',
  today: 'green',
};

export const TASK_ICON_MAPS: IconRecord = {
  touchpoint: 'american sign language interpreting',
  survey: 'write',
  'food-card': 'vcard',
  'confirm-food-card-balance': 'vcard',
  'food-box': 'box',
  'food-delivery': 'food',
  'other-goods-delivery': 'box',
  education: 'book',
  consultation: 'call',
  careplan: 'calendar alternate outline',
  communication: 'phone',
  'food-recall': 'food',
  triage: 'plus',
  outreach: 'handshake',
  automated: 'keyboard',
  member: 'user',
  voicemail: 'phone volume',
  'enrollment-action': 'paperclip',
};

export const TASK_STATUS_ICONS: Record<string, string> = {
  cancelled: CancelledIcon,
  completed: CompletedIcon,
  failed: FailedIcon,
  'in-progress': InProgressIcon,
  'on-hold': OnHoldIcon,
  received: OutreachIcon,
  requested: RequestedIcon,
};
